import { render } from "./PageHeaderBase.vue?vue&type=template&id=59f55716&ts=true"
import script from "./PageHeaderBase.vue?vue&type=script&lang=ts"
export * from "./PageHeaderBase.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__